import { SCHEDULEINFO_URLS } from "../../services/apiConfig.js";
import { SCHEDULE_ERRORS } from "../../common/constants/scheduleModule/scheduleConstants.js";
import apiClient from "../apiInstance.js";

export const getupcomingScheduleInfo = async () => {
    try {
        const response = await apiClient.post(SCHEDULEINFO_URLS.GET_UPCOMING_SCHEDULE);
        return response.data;
    } catch (error) {
        console.error(SCHEDULE_ERRORS.FETCH_SCHEDULES_ERROR, error);
        throw error;
    }
};

export const getupcomingMessages = async (monthFilter, page = 0, rowsPerPage = 10, search = "", statusFilter = "sent") => {
    try {
        const response = await apiClient.post(SCHEDULEINFO_URLS.GET_UPCOMING_MESSAGES, {
            monthFilter,
            page,
            rowsPerPage,
            search,
            statusFilter
        });
        // The backend should return { data: [...records], totalCount: number }
        return response.data;
    } catch (error) {
        console.error("Error fetching upcoming messages", error);
        throw error;
    }
};

export const getupcomingMessagesInfo = async ({ scheduleID, scheduleDataId, inactive }) => {
    try {
        const response = await apiClient.post(SCHEDULEINFO_URLS.GET_UPCOMING_MESSAGES_INFO, {
            scheduleID,
            scheduleDataId,
            inactive
        });
        return response.data;
    } catch (error) {
        console.error(SCHEDULE_ERRORS.FETCH_SCHEDULE_MESSAGES_ERROR, error);
        throw error;
    }
};

export const getarchiveScheduleInfo = async () => {
    try {
        const response = await apiClient.post(SCHEDULEINFO_URLS.GET_ARCHIVE_SCHEDULE);
        return response.data;
    } catch (error) {
        console.error(SCHEDULE_ERRORS.FETCH_SCHEDULE_MESSAGES_ERROR, error);
        throw error;
    }
};

export const getarchiveMessagesInfo = async () => {
    try {
        const response = await apiClient.post(SCHEDULEINFO_URLS.GET_ARCHIVE_MESSAGES);
        return response.data;
    } catch (error) {
        console.error(SCHEDULE_ERRORS.FETCH_SCHEDULE_MESSAGES_ERROR, error);
        throw error;
    }
};

export const updateScheduleMessage = async (updatedData) => {
    try {
        const response = await apiClient.post(SCHEDULEINFO_URLS.UPDATE_SCHEDULE_MESSAGE, updatedData);
        return response.data;
    } catch (error) {
        console.error(SCHEDULE_ERRORS.UPDATE_SCHEDULE_MESSAGE_ERROR, error);
        throw error;
    }
};

export const calibrateScheduleMessage = async (userId) => {
    try {
        const response = await apiClient.post(SCHEDULEINFO_URLS.UPDATE_ALL_SCHEDULE_DATA, { userId });
        return response.data;
    } catch (error) {
        console.error(SCHEDULE_ERRORS.UPDATE_ALL_SCHEDULE_DATA_ERROR, error);
        throw error;
    }
};

export const stopAllSchedulesMessage = async (userId) => {
    try {
      const response = await apiClient.post(SCHEDULEINFO_URLS.STOP_ALL_SCHEDULES, { userId });
      return response.data;
    } catch (error) {
      console.error(SCHEDULE_ERRORS.STOP_ALL_SCHEDULES_ERROR, error);
      throw error;
    }
  };